import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/apiClient";

const SettingsContext = createContext({ settings: null });

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    api.get("/public/settings").then(r => setSettings(r.data)).catch(() => setSettings({}));
  }, []);
  return <SettingsContext.Provider value={{ settings }}>{children}</SettingsContext.Provider>;
}

export function useSettings() {
  return useContext(SettingsContext);
}
